import { useState, useEffect } from 'react';
import Table from '../tablas/view';
import SpendTypeDropdown from './SpendTypeDropdown';
import ButtonBasic from '../../atoms/buttonBasic/view';
import './style.css';
import { getSpendTypes, matchSpendTypes } from '../../../usecases/spend-type-usecase';
import { listener } from '../../../utils/dispatch';

const SpendRelater = ({ array1, handleData = undefined }) => {
  const [relatedData, setRelatedData] = useState([]);
  const [spendTypes, setSpendTypes] = useState([]);
  const [loadingSpendTypes, setLoadingSpendTypes] = useState(false);

  // Inicialización de datos
  useEffect(() => {
    if (array1) {
      setRelatedData(array1.map(item => ({
        ...item,
        relatedItem: item.relatedItem || null,
        matchStatus: item.matchStatus || (item.relatedItem ? 'auto' : 'pending')
      })));
    }
  }, [array1]);

  // Fetch centralizado y Auto-Match + Listener
  useEffect(() => {
    if (array1?.length > 0) {
      loadSpendTypesAndAutoMatch();
    }

    const cleanReload = listener("reload-spend-types", () => {
      loadSpendTypesAndAutoMatch();
    });

    return () => cleanReload();
  }, [array1]);

  async function loadSpendTypesAndAutoMatch() {
    setLoadingSpendTypes(true);
    try {
      const res = await getSpendTypes(1, 100);
      const allSpendTypes = Array.isArray(res) ? res : (res?.data?.data || res?.data || []);
      setSpendTypes(allSpendTypes);

      // 2. Realizar coincidencia en el backend (catálogo completo)
      if (array1 && array1.length > 0) {
        const matchPayload = array1.map(item => ({
          idx: item.idx,
          description: item.description
        }));

        const matchRes = await matchSpendTypes(matchPayload);
        const matches = matchRes || [];

        setRelatedData(prevData => {
          const updated = prevData.map(item => {
            if (item.relatedItem) return item;
            const match = matches.find(m => m.idx === item.idx);
            if (match && match.related_item) {
              return calculateItemTotals({
                ...item,
                relatedItem: match.related_item,
                matchStatus: match.match_status // 'auto' | 'suggested' | 'pending'
              });
            }
            return item;
          });

          notify(updated);
          return updated;
        });
      }
    } catch (error) {
      console.error("Error loading spend types for SpendRelater:", error);
    } finally {
      setLoadingSpendTypes(false);
    }
  }

  function calculateItemTotals(item) {
    const updatedItem = { ...item };
    const subtotal = parseFloat(updatedItem.subtotal || 0);
    const tax = parseFloat(updatedItem.tax || 0);

    if (!updatedItem.total) {
      updatedItem.total = subtotal + tax;
    }

    updatedItem.unit_price = updatedItem.total / (parseFloat(updatedItem.quantity) || 1);
    return updatedItem;
  }

  const handleSpendTypeSelect = (selectedSpendType, item) => {
    setRelatedData(prev => {
      const updated = prev.map(dataItem => {
        if (dataItem.idx === item.idx) {
          return calculateItemTotals({ ...dataItem, relatedItem: selectedSpendType, matchStatus: 'manual' });
        }
        return dataItem;
      });
      notify(updated);
      return updated;
    });
  };

  function notify(data) {
    // Se removió el avance automático para requerir siempre la confirmación explícita del usuario mediante el botón "Confirmar y Continuar".
  }


  const relatedCount = relatedData.filter(item => item.relatedItem !== null).length;
  const totalCount = relatedData.length;
  const progressPercent = totalCount > 0 ? (relatedCount / totalCount) * 100 : 0;

  return (
    <div className="array-relater-container">
      <div className="relater-header">
        <div className="relater-header-top">
          <div className="progress-info">
            <h3>Relacionar Tipos de Gasto</h3>
            <span>{relatedCount} de {totalCount} relacionados</span>
          </div>
        </div>
        <div className="progress-bar-container">
          <div
            className="progress-bar-fill"
            style={{
              width: `${progressPercent}%`,
              backgroundColor: progressPercent === 100 ? 'var(--color-success)' : 'var(--color-primary)'
            }}
          />
        </div>
      </div>
      <div style={{ height: 'auto', overflowY: "hidden", margin: "0px" }}>
        <Table
          data={relatedData}
          isLoading={loadingSpendTypes}
          emptyMessage="No hay datos"
          headersList={["Descripción", "Total", "Tipo de Gasto"]}

          excludeList={["idx", "unit", "tax", "taxRate", "sku", "matchStatus", "subtotal", "quantity", "unit_price", "price"]}
          formats={{
            total: { type: "money" },
            relatedItem: {
              type: "custom",
              children: (item, idx) => (
                <div className='product-div-table'>
                  <SpendTypeDropdown
                    data={item}
                    spendTypes={spendTypes}
                    loading={loadingSpendTypes}
                    onSelected={(selectedSpendType) => handleSpendTypeSelect(selectedSpendType, item)}
                  />
                </div>
              )
            },
          }}
          allowSearch={false}
          allowExport={false}
        />
        {totalCount > 0 && (
          <div className="relater-footer" style={{ marginTop: '20px', paddingBottom: '10px', display: 'flex', justifyContent: 'flex-end' }}>
            <ButtonBasic
              disabled={relatedCount < totalCount}
              onClick={() => handleData?.(relatedData)}
              style={relatedCount === totalCount ? {
                backgroundColor: 'var(--color-success)',
                borderColor: 'var(--color-success)',
                color: 'white'
              } : {}}
            >
              Confirmar y Continuar
            </ButtonBasic>
          </div>
        )}
      </div>
    </div>
  );
};

export default SpendRelater;
